module.exports = __webpack_public_path__ + "b0c3d44f92260581401f950d6f2aae89.svg";